import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import AbstractEntityComponent from './AbstractEntityComponent';
import Gallery from './helpers/Gallery';
import HeadingImage from './helpers/HeadingImage';
import References from './helpers/References';
import Text from './helpers/Text';
import LinkList from './helpers/LinkList';

import { getYearString, getEntityDateState,} from '../helpers/date';
import * as DATE_STATES from '../helpers/date_states';
import { loadPage } from '../store/actions';
import AlfehrestDate from '../helpers/AlFehrestDate';

const mapStateToProps = (state) => ({
  initialDataStatus: state.initialDataStatus,
  dataLookup: state.dataLookup,
  listLookup: state.listLookup,
  pageCache: state.pageCache,
});

// Maps component props to action creators
const mapDispatchToProps = {
  loadPage: loadPage,
};

const propTypes = {
  id: PropTypes.number.isRequired,
  date: PropTypes.instanceOf(AlfehrestDate).isRequired,
};
const defaultProps = {};

class Ruler extends AbstractEntityComponent {
  constructor(props) {
    super(props);
  }

  getEntityType() {
    return 'ruler';
  }

  // TODO: Render Empty container when state is out of history
  renderEntity(data) {
    if (data.status === 'done') {
      let dateData = null;
      const state = this.props.dataLookup.states[data.state_id];
      const monumentList= this.props.listLookup.rulers.monuments[this.props.id];
      const eventList= this.props.listLookup.rulers.events[this.props.id];

      let startDate, endDate;
      [startDate, endDate] = AlfehrestDate.fromEntity(data);
      this.dateState = this.props.date.overlapsDates(startDate, endDate);
      switch (this.dateState[0]) {
        case DATE_STATES.PAST:
        case DATE_STATES.FUTURE:
          dateData = (
            <p>
              {data.name} هو أحد حكام
              {' '}
              <Link to={`/${this.props.date}/states/${state.id}`}>{state.name}</Link>
              {' '}
              لم يكن حاكما في {' '}
              <Link to={`/${this.props.date}`}>{this.props.date.toDefaultFormat()}</Link>
              {' '}
              {'('}<Link to={`/${startDate}/rulers/${data.id}`}>انتقل لذلك العهد</Link>{')'}
            </p>
          );
          break;
        case DATE_STATES.PRESENT:
          dateData = (
            <p>
              {data.name} هو أحد حكام
              {' '}
              <Link to={`/${this.props.date}/states/${state.id}`}>{state.name}</Link>
              {' من '}
              <Link to={`/${startDate}`}>{startDate.toDefaultFormat()}</Link>
              {' إلى '}
              <Link to={`/${endDate}`}>{endDate.toDefaultFormat()}</Link>
              {' '}
              {startDate.timeUntilString(endDate)}
            </p>
          );
          break;
      }

      return (
        <div>
          <HeadingImage title={data.name} images={data.images} type={this.entityType} date={this.props.date} />
          {dateData}
          <Text text={data.description || 'لم نكتب بعد عن هذا الحاكم'} maxLength={120} />
          <Gallery images={data.images} />
          <LinkList title="Monuments" entityType="monuments" list={monumentList} />
          <LinkList title="Events" entityType="events" list={eventList} />
          <References references={data.references} />
        </div>
      );
    }
  }
}

Ruler.defaultProps = defaultProps;
Ruler.propTypes = propTypes;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Ruler);
